import { cn } from '../../client/cn';
import type { UserFlair } from '../../shared/userFlair';

export type UserFlairBadgeVariant = 'compact' | 'default';

interface UserFlairBadgeProps {
  flair: UserFlair | null | undefined;
  variant?: UserFlairBadgeVariant;
  className?: string;
}

const flairLabel: Record<UserFlair, string> = {
  admin: 'Admin',
  supporter: 'Supporter',
  'super-supporter': 'Super Supporter',
};

const flairClasses: Record<UserFlair, string> = {
  admin: 'border-primary/70 bg-primary-600 text-white',
  supporter:
    'border-primary/30 bg-primary/10 text-primary-700 dark:border-primary/40 dark:text-primary-300',
  'super-supporter':
    'border-primary/45 bg-primary/20 text-primary-800 dark:border-primary/55 dark:text-primary-200',
};

const variantClasses: Record<UserFlairBadgeVariant, string> = {
  compact: 'px-1.5 py-0 text-[10px] leading-4',
  default: 'px-2 py-0.5 text-xs leading-5',
};

export function UserFlairBadge({
  flair,
  variant = 'default',
  className,
}: UserFlairBadgeProps) {
  if (!flair) {
    return null;
  }

  return (
    <span
      className={cn(
        'flair-badge inline-flex items-center rounded-full border font-medium whitespace-nowrap',
        flair === 'admin' && 'flair-badge-admin',
        variantClasses[variant],
        flairClasses[flair],
        className,
      )}
    >
      <span className="relative z-10">{flairLabel[flair]}</span>
    </span>
  );
}
